import React from "react";

export default function MapOverlay(props: {
  style: any;
  visible: boolean;
  children: React.ReactNode;
}) {
  if (!props.visible) {
    return null;
  }

  return (
    <div
      className="absolute bottom-0 right-0 left-0 w-full flex items-center justify-center mb-9 z-10 bg-grey-100 dark:bg-[#393939] border border-grey-400 dark:border-none rounded-lg max-w-[20rem] m-auto"
      style={props.style}
    >
      {props.children}
    </div>
  );
}
